import { useEffect, useRef, useState } from "react";
const useAlertDialogState = ()=>{
    const [isAlertDialogActive, setIsAlertDialogActive] = useState(false);
    const observerRef = useRef(null);
    useEffect(()=>{
        const checkAlertDialog = ()=>{
            const alertDialog = document.querySelector('[role="alertdialog"]');
            if (!alertDialog) return;
            const alertDialogParent = alertDialog.parentElement;
            const isVisible = alertDialogParent && 'none' !== window.getComputedStyle(alertDialogParent).display;
            setIsAlertDialogActive(!!isVisible);
        };
        checkAlertDialog();
        observerRef.current = new MutationObserver(checkAlertDialog);
        observerRef.current.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, []);
    return isAlertDialogActive;
};
export { useAlertDialogState };
